<template>
  <span
    class="rounded-[4px] empty:hidden font-bold"
    :class="[component.color, {'text-2xxs px-1 py-0.5 leading-normal': size === 'extra-small', 'inline-flex px-2 py-[2px] text-xs': size === 'small', 'inline-flex px-2 py-[2px] text-sm': size === 'standard'}]"
  >
    <slot v-if="$slots.default" />
  </span>
</template>

<script setup>
defineOptions({
  name: 'AtomsTag'
})

const props = defineProps({
  color: {
    type: String,
    default: 'white',
    validator: value => [
      'bordered', 'white', 'gray', 'green', 'pink', 'yellow', 'purple', 'purpled',
      'purplebd', 'blue', 'blue-crayola', 'blueb', 'darkb', 'cyanb', 'cyan', 'brown',
      'whiteb', 'grayb', 'successb', 'successbd', 'yellowb', 'errorb', 'errorbd',
      'orange', 'orangebd', 'disclaimer', 'deep-purple'
    ].includes(value)
  },
  size: {
    type: String,
    default: 'standard',
    validator: value => ['standard', 'small', 'extra-small'].includes(value)
  }
})

const component = computed(() => {
  const color = getKey(props.color, {
    bordered: 'bg-white text-dark border-dark border-solid border-1',
    white: 'bg-gray-350 text-dark',
    gray: 'bg-gray-600 text-dark',
    green: 'bg-primary text-dark',
    pink: 'bg-pink-600 text-white',
    yellow: 'bg-yellow-600 text-dark',
    purple: 'bg-purple-70 text-white',
    purpled: 'bg-purple-80 text-white',
    'deep-purple': 'bg-purple-100 text-white',
    purplebd: 'bg-purple-700 backdrop-opacity-5 text-dark border-1 border-solid border-purple-70',
    blue: 'bg-alert-info-fill text-dark',
    'blue-crayola': 'bg-blue-500 text-white',
    blueb: 'bg-alert-info-fill text-dark border-1 border-solid border-alert-info-stroke',
    darkb: 'bg-white text-dark border-1 border-solid border-dark',
    cyanb: 'bg-cyan-600 text-dark',
    cyan: 'bg-alert-info-fill border-1 border-solid border-cyan-600 text-cyan-600',
    brown: 'bg-[#9A5533] text-white',
    whiteb: 'bg-white text-dark border-1 border-solid border-blue-900',
    grayb: 'bg-gray-10 text-dark border-1 border-solid border-gray-400',
    successb: 'bg-alert-success-fill text-primary border-1 border-solid border-primary',
    successbd: 'bg-alert-success-fill text-dark border-1 border-solid border-primary',
    yellowb: 'bg-alert-warning-fill text-dark border-1 border-solid border-alert-warning-stroke',
    errorb: 'bg-alert-error-fill text-danger border-1 border-solid border-alert-error-stroke',
    errorbd: 'bg-alert-error-fill text-dark border-1 border-solid border-alert-error-stroke',
    orange: 'bg-orange-650 text-white',
    orangebd: 'bg-orange-750 text-dark border-1 border-solid border-orange-700',
    disclaimer: 'bg-gray-80 text-white'
  })

  return {
    color
  }
})
</script>
